import {
    getPlanFromCatalog,
    nextPlan,
    nextPlanBenefits,
    type SubscriptionPlanDefinition,
} from "@/domains/subscription/plans";
import { useSubscriptionPlans } from "@/domains/subscription/useSubscriptionPlans";

export function usePlanCatalog() {
    const query = useSubscriptionPlans();
    const catalog: SubscriptionPlanDefinition[] = Array.isArray(query.data) ? query.data : [];

    return {
        ...query,
        catalog,
        getPlan: (planId: string | null | undefined) => getPlanFromCatalog(catalog, planId),
        nextPlan: (planId: string | null | undefined) => nextPlan(planId, catalog),
        nextPlanBenefits: (planId: string | null | undefined) => nextPlanBenefits(planId, catalog),
    };
}
